export const EMAIL_CONFIG = {
  es: {
    serviceId: "service_zy_gmail",
    templateId: "template_4uomomi",
    contactId: "template_dqs4ovt",
    publicKey: "FYfais7YYSHXztoF_",
  },
  pt: {
    serviceId: "service_pt",
    templateId: "template_pzr8r8i",
    contactId: "template_71sqgii",
    publicKey: "efKkxAQo-geTzEGHt",
  },
};
